<template>
  <div class="page-container-content tabgroup">
    <!-- <w-objtype-bar></w-objtype-bar> -->
    <w-tool-tabs v-model="activeTabName" @tab-click="onClickTab">
      <el-tab-pane :label="tabs.summary.label" :name="tabs.summary.name">
          <w-root-perf-summary :active="tabs.summary.active"></w-root-perf-summary>
      </el-tab-pane>
      <el-tab-pane :label="tabs.performance.label" :name="tabs.performance.name">
        <div class="full-wrapper">
          <el-scrollbar :ref="`${tabs.performance.name}-scrollbar`">
            <div class="full">
              <w-objtype-bar :active="tabs.performance.active"></w-objtype-bar>
              <w-perf-info-group :active="tabs.performance.active" perf-view-type="list"></w-perf-info-group>
            </div>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="tabs.config.label" :name="tabs.config.name">
        <div class="full-wrapper">
          <el-scrollbar :ref="`${tabs.config.name}-scrollbar`">
            <div class="full">
              <w-objtype-bar :active="tabs.config.active"></w-objtype-bar>
              <w-config-group :active="tabs.config.active"></w-config-group>
            </div>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="tabs.flow.label" :name="tabs.flow.name" v-if="isFlowRole">
        <w-flow-analysis :active="tabs.flow.active"></w-flow-analysis>
      </el-tab-pane>
    </w-tool-tabs>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import RouterTab from '@/mixins/router/tab';
import ScrollbarMixin from '@/mixins/scrollbar';

import WConfigGroup from '@/views/config/group/';
import WObjtypeBar from '@/views/performance/group/components/ObjtypeBar';
import WPerfInfoGroup from '@/views/performance/group/perfinfo/';

import WTimeline from './components/Timeline';
import WFlowAnalysis from '../FlowAnalysis';
import WRootPerfSummary from './components/RootPerfSummary';

export default {
  name: 'WPerformanceRoot',
  components: {
    WTimeline,
    WPerfInfoGroup,
    WObjtypeBar,
    WConfigGroup,
    WFlowAnalysis,
    WRootPerfSummary,
  },
  mixins: [RouterTab, ScrollbarMixin],
  data() {
    return {
      tabs: {
        summary: {
          name: 'summary',
          label: '요약',
          active: false,
          default: true,
        },
        performance: {
          name: 'performance',
          label: '성능 정보',
          active: false,
        },
        config: {
          name: 'config',
          label: '구성 정보',
          active: false,
        },
        flow: {
          name: 'flow',
          label: 'Flow 분석',
          active: false,
        },
      },
      objCountInfo: {},
      selectedTimeline: {},
    };
  },
  props: {
    isFlowRole: {
      type: Boolean,
    },
  },
  methods: {
    onClickTab(to) {
      if (to) {
        this.scrollbarRef = `${to.name}-scrollbar`;
        if (!isNil(this.scrollbarRef)) {
          this.$nextTick(() => {
            this.setScrollData();
          });
        }
      }
      if (this.activeTabName === 'flow') {
        this.$store.dispatch('setInitialDatetimeRange', { type: 'interval', interval: 'hour', value: 1 }); // vuex에 시간구간 설정을 최근1시간으로 변경해준다
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/root/index.vue